import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const navItems = [
    {
        name: 'О системе',
        key: 'system',
        path: '/',
        submenu: [
            { name: 'NOXSYS', key: 'system', path: '/' },
            { name: 'Тарифы', key: 'price', path: '/price' },
        ],
    },
    {
        name: 'Справочники',
        key: 'guides',
        path: '/guides',
        submenu: [
            { name: 'ОКПД2', key: 'okpd2', path: '/guides/okpd2' },
            { name: 'ОКВЭД2', key: 'okved2', path: '/guides/okved2' },
        ],
    },
    {
        name: 'О компании',
        key: 'about',
        path: '/about',
        submenu: [
            { name: 'О нас', key: 'us', path: '/about/us' },
            {
                name: 'Информация о компании',
                key: 'companydocs',
                path: '/about/companydocs',
            },
            { name: 'Контакты', key: 'contacts', path: '/about/contacts' },
        ],
    },
    {
        name: 'Документы',
        key: 'docs',
        path: '/docs',
        submenu: [
            {
                name: 'Политика конфиденциальности',
                key: 'privacy-policy',
                path: '/docs/privacy-policy',
            },
            {
                name: 'Пользовательское соглашение',
                key: 'user-agreement',
                path: '/docs/user-agreement',
            },
            {
                name: 'Описание функциональных характеристик программного обеспечения и информация, необходимая для установки и эксплуатации программного обеспечения',
                key: 'manual',
                path: '/docs/manual',
            },
        ],
    },
]

type Props = {
    onClick: () => void
}

export const MenuNavigation: React.FC<Props> = ({ onClick }) => {
    const [activeTab, setActiveTab] = useState('system')

    return (
        <ul className="flex flex-col w-full md:relative md:flex-row md:py-2 md:gap-3 font-semibold">
            {navItems.map((item) => {
                const isActive = activeTab === item.key
                return (
                    <li key={item.key}>
                        <button
                            className={
                                'w-full px-5 py-2 text-[14px] text-gray-800 md:rounded-md md:transition-all md:duration-300 hover:bg-[#e4e7ea] ' +
                                (isActive ? 'bg-[#e4e7ea] ' : '')
                            }
                            onClick={() => setActiveTab(item.key)}
                        >
                            {item.name}
                        </button>

                        <div
                            className={
                                'md:absolute md:flex-row md:left-0 md:py-2 ' +
                                (isActive ? 'md:flex' : 'hidden')
                            }
                        >
                            <div className="hidden md:flex md:w-[250px] lg:w-[500px] py-[20px] text-[32px]">
                                {item.name}
                            </div>
                            <div className="flex flex-col md:gap-3 md:py-5 md:items-start text-[12px] md:text-[18px]">
                                {item.submenu.map((subitem) => (
                                    <Link
                                        key={subitem.key}
                                        to={subitem.path}
                                        onClick={onClick}
                                        className="px-3 py-1 text-gray-800 hover:bg-[#e4e7ea] md:rounded-md md:transition-all md:duration-300"
                                    >
                                        {subitem.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </li>
                )
            })}
        </ul>
    )
}
